(function (window, document) {
  "use strict";

  /*
    ==========================================================
    NUPEP Events Engine
    Version: 2.0.0
    ==========================================================
    */

  if (!window.NUPEP) {
    console.error("[NUPEP Events] Core framework missing.");
    return;
  }

  const PREFIX = "nupep:";

  /*
    ==========================================================
    Event Registry
    ==========================================================
    */

  const NAMES = Object.freeze({
    PRODUCT_INIT: "product:init",
    PRODUCT_RESET: "product:reset",

    VARIANT_CHANGE: "variant:change",

    SELLING_PLAN_CHANGE: "selling-plan:change",

    PURCHASE_TYPE_CHANGE: "purchase-type:change",

    QUANTITY_CHANGE: "quantity:change",

    PRICE_CHANGE: "price:change",

    COMPARE_PRICE_CHANGE: "compare-price:change",

    AVAILABILITY_CHANGE: "availability:change",

    CART_ADD: "cart:add",

    CART_UPDATE: "cart:update",

    CART_REMOVE: "cart:remove",

    SUBSCRIPTION_SELECTED: "subscription:selected",

    SUBSCRIPTION_REMOVED: "subscription:removed",
  });

  /*
    ==========================================================
    Event Engine
    ==========================================================
    */

  const Events = {
    NAMES,

    emit(name, detail = {}) {
      document.dispatchEvent(
        new CustomEvent(PREFIX + name, {
          detail,
        }),
      );

      if (window.NUPEP.config?.debug) {
        console.log(`[NUPEP Event] ${name}`, detail);
      }
    },

    on(name, callback) {
      document.addEventListener(PREFIX + name, callback);
    },

    once(name, callback) {
      document.addEventListener(PREFIX + name, callback, {
        once: true,
      });
    },

    off(name, callback) {
      document.removeEventListener(PREFIX + name, callback);
    },
  };

  Object.freeze(Events);

  window.NUPEP.Events = Events;

  console.log("[NUPEP Events] Ready.");
})(window, document);
